<div class="overlay-inner-wrapper">
  <header class="header-2">
    <div class="branding">
      <span class="title">{{ 'Begehungen verwalten' | mrTranslate }}</span>
    </div>
    <div class="header-actions">
      <a href="javascript://" class="nav-link nav-icon">
        <cds-icon shape="times" (click)="close()"></cds-icon>
      </a>
    </div>
  </header>
  <div class="w-100-p padding-10-lr padding-12-tb scroll-y h-60">
    <div class="clr-row nxm h-100">
      <div class="card clr-col-4 nm item-table h-100">
        <div class="card-header">{{ 'Begehungsart' | mrTranslate }}</div>
        <div class="card-block np">
          @if (begehungsTable().columns.length) {
            <clr-datagrid
              class="datagrid-compact h-100"
              [clrDgSelectionType]="'single'"
              [clrDgSelected]="[selectedBegehung()]"
              (clrDgSelectedChange)="selectedBegehung.set($event[0])"
              [clrDgItemsIdentityFn]="row => row?.ID"
              [clrDgRowSelection]="true">
              @for (column of begehungsTable().columns; track column.id) {
                <clr-dg-column [clrDgField]="column.id">
                  <ng-container *clrDgHideableColumn="{ hidden: column.id | hideIDColumns: ['tag', 'gruppen'] }">
                    {{ column.id | titlecase | mrUnitText }}
                  </ng-container>
                </clr-dg-column>
              }
              <clr-dg-row *clrDgItems="let row of begehungsTable().rows" [clrDgItem]="row">
                @for (cell of begehungsTable().columns; track cell.id) {
                  <clr-dg-cell class="name-cell">{{ row[cell.id] | tablePrettyPrint }}</clr-dg-cell>
                }
              </clr-dg-row>
              <clr-dg-footer>{{ begehungsTable().rows.length }} {{ 'Zeilen' | mrTranslate }}</clr-dg-footer>
            </clr-datagrid>
          }
        </div>
        <div class="card-footer">
          <div class="btn-group btn-primary btn-icon margin-0-t clr-flex-shrink-0">
            <button
              type="submit"
              form="begehung-form"
              class="btn btn-success"
              [title]="'Speichern' | mrTranslate"
              [disabled]="!(isInsertNeu() || obegeid())">
              <cds-icon shape="floppy" />
            </button>
            <button
              class="btn btn-danger"
              [title]="'Löschen' | mrTranslate"
              (click)="deleteBegehung()"
              [disabled]="!obegeid()">
              <cds-icon shape="times" />
            </button>
            <button
              class="btn"
              [title]="'Neu' | mrTranslate"
              (click)="isInsertNeu.set(true)"
              [disabled]="isInsertNeu()">
              <cds-icon shape="file" />
            </button>
          </div>
          <span class="name-cell">
            {{
              (isInsertNeu() ? 'neue Begehungsart erstellen'
              : obegeid() ? 'ausgewählte Begehungsart bearbeiten'
              : ''
              ) | mrTranslate
            }}
          </span>
        </div>
      </div>
      <div class="clr-col-md-8 h-100">
        <!-- <h4 style="margin-block: 12px;">{{ "Einstellungen" | mrTranslate }}</h4> -->
        <clr-tabs>
          <clr-tab #form>
            <button clrTabLink>{{ 'Begehung' | mrTranslate }}</button>
            <clr-tab-content>
              <form
                id="begehung-form"
                clrForm
                (ngSubmit)="formGroup.valid && saveItem()"
                [formGroup]="formGroup"
                class="width100 clr-row nxm h-100"
                [clrLabelSize]="4">
                <div class="clr-col-6 padding-12-r">
                  <clr-input-container>
                    <label class="clr-required-mark">{{ 'Begehungsart' | mrTranslate }}</label>
                    <input clrInput formControlName="Begehungsart" [placeholder]="'Bezeichnung eingeben' | mrTranslate" />
                    <clr-control-error *clrIfError="'required'">
                      {{ 'Das Feld muss ausgefüllt werden' | mrTranslate }}
                    </clr-control-error>
                  </clr-input-container>
                  <clr-date-container>
                    <label class="clr-required-mark">{{ 'Beginn' | mrTranslate }}</label>
                    <input
                      type="date"
                      clrDate
                      autocomplete="off"
                      [ngModel]="dateControl | localeDate"
                      (ngModelChange)="dateControl = localeDate.tosql($event)"
                      [ngModelOptions]="{ updateOn: 'blur', standalone: true }"
                      [disabled]="formGroup.disabled"
                      required />
                    <clr-control-error *clrIfError="'required'">
                      {{ 'Das Feld muss ausgefüllt werden' | mrTranslate }}
                    </clr-control-error>
                  </clr-date-container>
                  <clr-number-input-container>
                    <label class="clr-required-mark">{{ 'Intervall in Wochen' | mrTranslate }}</label>
                    <input type="number" clrNumberInput formControlName="Intervall" />
                    <clr-control-error *clrIfError="'required'">
                      {{ 'Erforderlich' | mrTranslate }}
                    </clr-control-error>
                    <clr-control-error *clrIfError="'min'">
                      {{ 'Mindestens 1' | mrTranslate }}
                    </clr-control-error>
                  </clr-number-input-container>
                  <clr-radio-container>
                    <clr-radio-wrapper>
                      <input type="radio" clrRadio [value]="1" formControlName="Tag" />
                      <label>{{ 'Montag' | mrTranslate }}</label>
                    </clr-radio-wrapper>
                    <clr-radio-wrapper>
                      <input type="radio" clrRadio [value]="2" formControlName="Tag" />
                      <label>{{ 'Dienstag' | mrTranslate }}</label>
                    </clr-radio-wrapper>
                    <clr-radio-wrapper>
                      <input type="radio" clrRadio [value]="3" formControlName="Tag" />
                      <label>{{ 'Mittwoch' | mrTranslate }}</label>
                    </clr-radio-wrapper>
                    <clr-radio-wrapper>
                      <input type="radio" clrRadio [value]="4" formControlName="Tag" />
                      <label>{{ 'Donnerstag' | mrTranslate }}</label>
                    </clr-radio-wrapper>
                    <clr-radio-wrapper>
                      <input type="radio" clrRadio [value]="5" formControlName="Tag" />
                      <label>{{ 'Freitag' | mrTranslate }}</label>
                    </clr-radio-wrapper>
                    <clr-radio-wrapper>
                      <input type="radio" clrRadio [value]="6" formControlName="Tag" />
                      <label>{{ 'Samstag' | mrTranslate }}</label>
                    </clr-radio-wrapper>
                    <clr-radio-wrapper>
                      <input type="radio" clrRadio [value]="7" formControlName="Tag" />
                      <label>{{ 'Sonntag' | mrTranslate }}</label>
                    </clr-radio-wrapper>
                  </clr-radio-container>
                  <clr-textarea-container>
                    <label>{{ 'Beschreibung' | mrTranslate }}</label>
                    <textarea clrTextarea formControlName="Beschreibung"></textarea>
                  </clr-textarea-container>
                </div>
                <div class="clr-col-6">
                  <clr-input-container>
                    <label class="clr-required-mark">{{ 'Benutzergruppen' | mrTranslate }}</label>
                    <input type="text" clrInput hidden formControlName="Gruppen" />
                    <clr-control-error *clrIfError="'required'">
                      {{ 'Wählen Sie mindestens eine Gruppe aus' | mrTranslate }}
                    </clr-control-error>
                  </clr-input-container>
                  <clr-datagrid
                    class="datagrid-compact w-100-p"
                    [clrDgSelectionType]="'multi'"
                    [clrDgSelected]="selectedGroups()"
                    (clrDgSelectedChange)="selectedGroups.set($event)"
                    [clrDgItemsIdentityFn]="row => row?.id">
                    <clr-dg-column>{{ 'Bezeichnung' | mrTranslate }}</clr-dg-column>
                    <clr-dg-row
                      *clrDgItems="let item of groups()"
                      [clrDgItem]="item"
                      [clrDgSelectable]="formGroup.enabled">
                      <clr-dg-cell>{{ item['Bezeichnung'] }}</clr-dg-cell>
                    </clr-dg-row>
                  </clr-datagrid>
                </div>
              </form>
            </clr-tab-content>
          </clr-tab>

          <clr-tab>
            <button clrTabLink [disabled]="!obegeid()">
              {{ 'Objekte' | mrTranslate }}
              <span class="badge badge-info margin-3-l">{{ zugeordneteObjekte().rows.length }}</span>
            </button>

            <clr-tab-content *clrIfActive>
              <div class="clr-row nxm" style="align-items: center">
                <div class="clr-col-auto margin-12-tb d-f clr-align-items-center">
                  <app-all-selected-btn
                    class="nym"
                    [(selected)]="selectedZuordnungen"
                    [all]="filteredZugeordneteObjekte()" />
                  <div class="btn-group btn-primary btn-icon">
                    <button class="btn" [title]="'Neu' | mrTranslate" (click)="isAddObjekteModalOpen.set(true)">
                      <cds-icon shape="file" />
                    </button>
                    <button
                      class="btn btn-danger"
                      [title]="'Löschen' | mrTranslate"
                      (click)="deleteObjekteZuordnungen()"
                      [disabled]="!selectedZuordnungen().length">
                      <cds-icon shape="times" />
                    </button>
                    @if (filteredZugeordneteObjekte().length != zugeordneteObjekte().rows.length) {
                      <button class="btn btn-outline" (click)="filterStore_II.deleteAllFilters()">
                        <clr-tooltip>
                          <cds-icon clrTooltipTrigger shape="filter-off" />
                          <clr-tooltip-content [clrPosition]="'bottom-right'" [clrSize]="'md'">
                            {{ 'Alle Filter zurücksetzen' | mrTranslate }}
                          </clr-tooltip-content>
                        </clr-tooltip>
                      </button>
                    }
                  </div>
                </div>
              </div>
              @if (objekte().columns.length) {
                <clr-datagrid
                  #zuordnungen
                  class="datagrid-compact h-60"
                  [clrDgSelectionType]="'multi'"
                  [clrDgSelected]="selectedZuordnungen()"
                  (clrDgSelectedChange)="selectedZuordnungen.set($event)"
                  [clrDgItemsIdentityFn]="row => row?.OSTAMMID"
                  [clrDgRowSelection]="true">
                  @for (column of objekte().columns; track column.id) {
                    <clr-dg-column [clrDgField]="column.id">
                      <clr-dg-filter>
                        <app-column-filter
                          #zugeordnet
                          [column]="column"
                          [objektTypIconValue]="filterStore_II.iconMap()"
                          [uniqueColumnValues]="filterStore_II.uniqueValues()[column.id]"
                          (changes)="filterStore_II.onChange($event)" />
                      </clr-dg-filter>

                      <ng-container
                        *clrDgHideableColumn="{ hidden: column.id | hideIDColumns: ['sp', 'lf', 'st', 'rep'] }">
                        {{ column.id | titlecase | mrTranslate }}
                      </ng-container>
                    </clr-dg-column>
                  }

                  <ng-template
                    clrVirtualScroll
                    let-row
                    [clrVirtualRowsOf]="filteredZugeordneteObjekte()"
                    [clrVirtualRowsTrackBy]="(_, row) => row?.OSTAMMID"
                    [clrVirtualRowsItemSize]="33">
                    <clr-dg-row [clrDgItem]="row">
                      @for (cell of objekte().columns; track cell.id) {
                        <clr-dg-cell><app-icon-dg-cell [column]="cell" [row]="row" /></clr-dg-cell>
                      }
                    </clr-dg-row>
                  </ng-template>
                  <clr-dg-footer>{{ filteredZugeordneteObjekte().length }} {{ 'Zeilen' | mrTranslate }}</clr-dg-footer>
                </clr-datagrid>
              }
            </clr-tab-content>
          </clr-tab>
        </clr-tabs>
      </div>
    </div>
  </div>
</div>

@if (isAddObjekteModalOpen()) {
  <clr-modal
    #modal
    [clrModalOpen]="isAddObjekteModalOpen()"
    (clrModalOpenChange)="isAddObjekteModalOpen.set($event)"
    [clrModalSize]="'xl'">
    <h3 class="modal-title">
      {{ 'Objekte hinzufügen' | mrTranslate }}
      <app-all-selected-btn class="btn-sm" [(selected)]="selectedObjekte" [all]="filteredAlleObjekte()" />
      @if (filteredAlleObjekte().length != objekte().rows.length) {
        <button class="btn btn-primary btn-sm btn-icon" (click)="filterStore.deleteAllFilters()">
          <clr-tooltip>
            <cds-icon clrTooltipTrigger shape="filter-off" />
            <clr-tooltip-content [clrPosition]="'bottom-right'" [clrSize]="'md'">
              {{ 'Alle Filter zurücksetzen' | mrTranslate }}
            </clr-tooltip-content>
          </clr-tooltip>
        </button>
      }
    </h3>
    <div class="modal-body">
      @if (objekte().columns.length) {
        <clr-datagrid
          class="datagrid-compact h-100"
          style="min-height: 60vh"
          [clrDgSelectionType]="'multi'"
          [clrDgSelected]="selectedObjekte()"
          (clrDgSelectedChange)="selectedObjekte.set($event)"
          [clrDgItemsIdentityFn]="row => row?.OSTAMMID"
          [clrDgRowSelection]="true">
          @for (column of objekte().columns; track column.id) {
            <clr-dg-column [clrDgField]="column.id">
              <clr-dg-filter>
                <app-column-filter
                  #all
                  [column]="column"
                  [objektTypIconValue]="filterStore.iconMap()"
                  [uniqueColumnValues]="filterStore.uniqueValues()[column.id]"
                  (changes)="filterStore.onChange($event)" />
              </clr-dg-filter>

              <ng-container *clrDgHideableColumn="{ hidden: column.id | hideIDColumns: ['sp', 'lf', 'st', 'rep'] }">
                {{ column.id | titlecase | mrTranslate }}
              </ng-container>
            </clr-dg-column>
          }

          <ng-template
            clrVirtualScroll
            let-row
            [clrVirtualRowsOf]="filteredAlleObjekte()"
            [clrVirtualRowsTrackBy]="(_, row) => row?.OSTAMMID"
            [clrVirtualRowsItemSize]="32">
            <clr-dg-row [clrDgItem]="row">
              @for (cell of objekte().columns; track cell.id) {
                <clr-dg-cell><app-icon-dg-cell [column]="cell" [row]="row" /></clr-dg-cell>
              }
            </clr-dg-row>
          </ng-template>
          <clr-dg-footer>{{ filteredAlleObjekte().length }} {{ 'Zeilen' | mrTranslate }}</clr-dg-footer>
        </clr-datagrid>
      }
    </div>
    <div class="modal-footer">
      <button
        type="button"
        class="btn btn-success"
        [disabled]="!selectedObjekte().length"
        (click)="addObjektZuordnungen()">
        {{ 'Hinzufügen' | mrTranslate }}
      </button>
      <button type="button" class="btn" (click)="modal.close()">{{ 'Beenden' | mrTranslate }}</button>
    </div>
  </clr-modal>
}
